import { z } from "zod";
import { Id } from "../common/ids.js";
/**
 * The envelopes of the platform's entries in a conversation's log (ADR 0029; `docs/05-api-contracts.md` section 7),
 * versioned with `v`: cards, files, and notices, which only the platform appends. Clients render them; a card names
 * its entity and is always read afresh. Until card 155 they are also OpenIM's custom messages, which its callbacks
 * check (ADR 0016 point 3).
 */
export const CardPayload = z
    .strictObject({
    v: z.literal(1),
    kind: z.literal("card"),
    entityType: z.string().regex(/^[a-z_]{2,40}$/),
    entityId: z.string().min(1).max(64),
    entityVersion: z.number().int().nonnegative(),
})
    .meta({ id: "CardPayload" });
export const FilePayload = z
    .strictObject({
    v: z.literal(1),
    kind: z.literal("file"),
    fileId: Id,
    name: z.string().min(1).max(200),
    contentType: z.string().min(3).max(120),
    sizeBytes: z.number().int().positive(),
})
    .meta({ id: "FilePayload" });
export const NoticePayload = z
    .strictObject({
    v: z.literal(1),
    kind: z.literal("notice"),
    code: z.string().regex(/^[a-z][a-z_.-]{2,79}$/),
    params: z.record(z.string(), z.string()),
})
    .meta({ id: "NoticePayload" });
export const CustomPayload = z.discriminatedUnion("kind", [CardPayload, FilePayload, NoticePayload]);
//# sourceMappingURL=payloads.js.map